import { useMediaQuery } from "@uidotdev/usehooks"
import OnboardingManager from "components/OnboardingManager"
import PageContainer from "components/PageContainer"
import TopHeadingBar from "components/TopHeadingBar"
import AIToolsSection from "features/AItools/QuickAccess"
import { useAutomaticNotificationAction } from "features/Notifications/hooks/useAutomaticNotificationAction"
import { CompleteOnboardingCards } from "features/SignupOnboarding/CompleteOnboardingCards"
import FreeTrialCard from "features/SuraasaPlus/FreeTrial/Card"
import { breakpoints } from "utils/createBreakpoints"

import CpatBanner from "../Cpat/Banners/CpatHomeScreenBanner"
import UpcomingMasterclass from "../Masterclasses/UpcomingMasterclass"
import ExploreResources from "./ExploreResources"
import GetStartedWithProgramsBanner from "./GetStartedWithProgramsBanner"
import NeedCareerAdviceBanner from "./NeedCareerAdvice"
import NeedHelpBanner from "./NeedHelpBanner"
import OfferLetterBanner from "./OfferLetter/PgCTL/OfferLetterBanner"
import ResumeLearning from "./ResumeLearning"
import ScheduleBanner from "./ScheduleBanner"
import ResumeSuraasaPlusTour from "./SuraasaPlusNewYearOnboarding/DashboardTour/ResumeSuraasaPlusTour"

const Home = () => {
  const isSmDown = useMediaQuery(breakpoints.down("sm"))

  // Automatically detects and handles notification actions from the URL (if present).
  useAutomaticNotificationAction()

  return (
    <div className="relative h-full min-h-screen bg-white">
      <TopHeadingBar heading="Home" renderBorder />
      {isSmDown ? (
        <PageContainer className="mt-2 !pb-10">
          <FreeTrialCard />
          <CpatBanner />
          <UpcomingMasterclass />
          <OfferLetterBanner />
          <CompleteOnboardingCards />
          <ResumeSuraasaPlusTour />
          <NeedCareerAdviceBanner />
          <ScheduleBanner />
          <GetStartedWithProgramsBanner />
          <ResumeLearning className="mb-4.5" />
          <AIToolsSection />
          <ExploreResources />
          <NeedHelpBanner />
        </PageContainer>
      ) : (
        <PageContainer className="mt-2 !pb-10 max-sm:px-0">
          <div className="grid grid-cols-12 sm:gap-2 md:gap-3">
            <div className="col-span-12 flex flex-col sm:col-span-7 md:col-span-8">
              <FreeTrialCard />
              <CpatBanner />
              <UpcomingMasterclass />
              <OfferLetterBanner />
              <CompleteOnboardingCards />
              <GetStartedWithProgramsBanner />
              <ResumeLearning className="mb-4.5" />
              <AIToolsSection />
              <ExploreResources />
            </div>

            <div className="col-span-12 flex flex-col sm:col-span-5 md:col-span-4">
              <ResumeSuraasaPlusTour />
              <NeedCareerAdviceBanner />
              <ScheduleBanner />
              <NeedHelpBanner />
            </div>
          </div>
        </PageContainer>
      )}
      <OnboardingManager />
    </div>
  )
}

export default Home
